<div class="absolute inset-0 flex min-w-0 flex-col overflow-hidden">
    <div class="bg-card h-full flex-auto dark:bg-transparent">
        <div class="flex flex-auto flex-col">
                <div class="bg-default flex flex-col items-start gap-4 px-6 py-8 sm:flex-row sm:items-center sm:justify-between md:px-8">
                <div class="flex items-center gap-4">
                    <img
                        src="/images/logo/logo-text.svg"
                        alt="Bookletics"
                        class="h-12 w-auto"
                    />
                    <div>
                        <div class="text-4xl font-extrabold leading-none tracking-tight">Account Deletion</div>
                        <div class="text-secondary ml-0.5 font-medium">
                            <span>Bookletics</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex-1 overflow-y-auto px-6 py-4 md:px-8">
                <mat-card class="max-w-3xl mx-auto !bg-white shadow-lg">
                    <div class="p-6 md:p-8 space-y-6 text-gray-700">
                        <p class="text-lg leading-relaxed">
                            Enter your email address to receive a one-time verification code. After you confirm the
                            code, your account will be deleted.
                        </p>

                        <div *ngIf="step !== 'done'" class="rounded-lg border border-gray-200 bg-gray-50 p-5">
                            <div class="flex items-center gap-2 text-gray-900 font-semibold">
                                <mat-icon>mark_email_read</mat-icon>
                                Step 1: Request verification code
                            </div>
                            <form class="mt-4 space-y-4" [formGroup]="requestForm" (ngSubmit)="sendOtp()">
                                <mat-form-field appearance="outline" class="w-full">
                                    <mat-label>Email address</mat-label>
                                    <input matInput type="email" formControlName="email" autocomplete="email" />
                                    <mat-error *ngIf="requestForm.controls.email.hasError('required')">
                                        Email is required.
                                    </mat-error>
                                    <mat-error *ngIf="requestForm.controls.email.hasError('email')">
                                        Enter a valid email address.
                                    </mat-error>
                                </mat-form-field>

                                <button
                                    mat-flat-button
                                    color="primary"
                                    type="submit"
                                    [disabled]="isSending"
                                >
                                    <mat-progress-spinner
                                        *ngIf="isSending"
                                        diameter="18"
                                        mode="indeterminate"
                                    ></mat-progress-spinner>
                                    <span class="ml-2">{{ isSending ? 'Sending...' : 'Send code' }}</span>
                                </button>
                            </form>
                        </div>

                        <div *ngIf="step !== 'request'" class="rounded-lg border border-gray-200 bg-white p-5">
                            <div class="flex items-center gap-2 text-gray-900 font-semibold">
                                <mat-icon>verified</mat-icon>
                                Step 2: Verify code and delete account
                            </div>
                            <form class="mt-4 space-y-4" [formGroup]="verifyForm" (ngSubmit)="verifyOtp()">
                                <mat-form-field appearance="outline" class="w-full">
                                    <mat-label>Verification code</mat-label>
                                    <input matInput formControlName="otp" autocomplete="one-time-code" />
                                    <mat-hint>Enter the 4-digit code sent to your email.</mat-hint>
                                    <mat-error *ngIf="verifyForm.controls.otp.hasError('required')">
                                        Verification code is required.
                                    </mat-error>
                                    <mat-error *ngIf="verifyForm.controls.otp.hasError('pattern')">
                                        Code must be 4 digits.
                                    </mat-error>
                                </mat-form-field>

                                <div *ngIf="errorMessage" class="text-sm text-warn-700">
                                    {{ errorMessage }}
                                </div>

                                <div class="flex flex-wrap gap-3">
                                    <button
                                        mat-flat-button
                                        color="warn"
                                        type="submit"
                                        [disabled]="isVerifying"
                                    >
                                        <mat-progress-spinner
                                            *ngIf="isVerifying"
                                            diameter="18"
                                            mode="indeterminate"
                                        ></mat-progress-spinner>
                                        <span class="ml-2">{{ isVerifying ? 'Deleting...' : 'Delete account' }}</span>
                                    </button>
                                    <button mat-stroked-button type="button" (click)="resendOtp()">
                                        Resend code
                                    </button>
                                    <button mat-button type="button" (click)="editEmail()">
                                        Change email
                                    </button>
                                </div>
                            </form>
                        </div>

                        <div *ngIf="step === 'done'" class="rounded-lg border border-green-200 bg-green-50 p-5">
                            <div class="flex items-center gap-2 text-green-900 font-semibold">
                                <mat-icon>check_circle</mat-icon>
                                Account deleted
                            </div>
                            <p class="mt-2 text-sm text-green-800">
                                Your account has been deleted. Personal data will be removed within 30 days unless
                                retention is required for legal or financial reasons.
                            </p>
                        </div>

                        <div class="rounded-lg border border-warn/40 bg-warn-50 p-5">
                            <div class="flex items-center gap-2 text-warn-900 font-semibold">
                                <mat-icon>warning</mat-icon>
                                What data is deleted
                            </div>
                            <ul class="mt-3 list-disc space-y-2 pl-5 text-sm leading-6">
                                <li>Your profile, contact details, and authentication tokens are erased.</li>
                                <li>Active bookings, invitations, chats, and notifications linked to you are withdrawn or anonymized.</li>
                                <li>We retain only the minimum information required for legal or financial obligations.</li>
                            </ul>
                        </div>

                        <div class="rounded-lg border border-gray-200 bg-white p-5">
                            <div class="flex items-center gap-2 text-gray-900 font-semibold">
                                <mat-icon>help</mat-icon>
                                Need help?
                            </div>
                            <p class="mt-3">
                                Contact support at
                                <a class="text-primary underline" href="mailto:support@bookletics.com">support&#64;bookletics.com</a>.
                            </p>
                        </div>
                    </div>
                </mat-card>
            </div>
        </div>
    </div>
</div>
